/** API呼び出し・既読更新の前に、正の安全な整数IDであることを確認する。 */
export const isValidProposalId = (id: number | undefined): id is number =>
  typeof id === "number" && Number.isSafeInteger(id) && id > 0;
